import React from "react";

export const PasswordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[’`~!@#$%^&*()\-=_+<>|\\/?.,{}[\]:;"'])(?!.*\s)[A-Za-z0-9’`~!@#$%^&*()\-=_+<>|\\/?.,{}[\]:;"']{8,}$/;
export const EmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const UsernamePattern = /^[a-zA-Z0-9]+$/;
export const ConfirmationCodePattern = /^\d{6}$/;

// Password validation checks
export const getPasswordRecommendations = (password: string) => [
  {
    message: 'Make it at least 8 characters',
    valid: password.length >= 8
  },
  {
    message: 'Add lowercase letters',
    valid: /[a-z]/.test(password)
  },
  {
    message: 'Add uppercase letters',
    valid: /[A-Z]/.test(password)
  },
  {
    message: 'Add numbers',
    valid: /\d/.test(password)
  },
  {
    message: 'Add punctuation',
    valid: /[’`~!@#$%^&*()\-=_+<>|\\/?.,{}[\]:;"']/g.test(password)
  },
  {
    message: 'Avoid spaces and disallowed symbols',
    valid: !/\s/.test(password) && /^[a-zA-Z0-9’`~!@#$%^&*()\-=_+<>|\\/?.,{}[\]:;"']*$/.test(password)
  }
];

// Password strength calculation
export const getPasswordStrength = (passwordRecommendations: any[]) => {
  const validCount = passwordRecommendations.filter(rec => rec.valid).length;
  if (validCount < 2) return 'Very Weak';
  if (validCount === 2) return 'Weak';
  if (validCount === 3) return 'Fair';
  if (validCount === 4) return 'Medium';
  if (validCount === 5) return 'Strong';
  return 'Very Strong';
};

export const getNewEthnicGroups = (event: React.ChangeEvent<HTMLInputElement>, ethnicGroup: string[]) => {
  const value = event.target.name;
  let newEthnicGroups;
  if (value === 'prefernottoanswer') {
    // Reset selections and only keep "prefernottoanswer"
    newEthnicGroups = ['prefernottoanswer'];
  } else if (ethnicGroup.includes('prefernottoanswer')) {
    // If "prefernottoanswer" is selected, it should be deselected and not added
    newEthnicGroups = [value];
  } else {
    // Toggle the checkbox selection
    newEthnicGroups = ethnicGroup.includes(value) ? ethnicGroup.filter(item => item !== value) : [...ethnicGroup, value];
  }
  return newEthnicGroups;
};
